/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */
import React, { Fragment } from "react";
import utils from "./utils";
import px2rem from './px2rem';

String.prototype.colorRgb = function() {
  var sColor = this.toLowerCase();
  //十六进制颜色值的正则表达式
  var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
  // 如果是16进制颜色
  if (sColor && reg.test(sColor)) {
      if (sColor.length === 4) {
          var sColorNew = "#";
          for (var i=1; i<4; i+=1) {
              sColorNew += sColor.slice(i, i+1).concat(sColor.slice(i, i+1));    
          }
          sColor = sColorNew;
      }
      //处理六位的颜色值
      var sColorChange = [];
      for (var i=1; i<7; i+=2) {
          sColorChange.push(parseInt("0x"+sColor.slice(i, i+2)));    
      }
      return "rgba(" + sColorChange.join(",") + ', 0.5' + ")";
  }
  return sColor;
};

class CountDown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      count_down: {
        d: "00",
        h: "00",
        m: "00",
        s: "00",
      }
    };
    this.isEnded = false;
    this.timer = null;
  }

  componentDidMount() {
    let { countDownTime } = this.props;
    if (countDownTime) {
      countDownTime = countDownTime.replace('T', ' ');
      this.startCountDown(countDownTime)
    }
  }

  componentWillUnmount() {
    clearInterval(this.timer);
    this.timer = null;
    this.isEnded = false;
  }

  renderCountDown() {
    let { countDownTextColor, countDownBgColor } = this.props;
    const { d, h, m, s } = this.state.count_down;
    countDownBgColor = countDownBgColor.colorRgb();
    if (!this.isEnded) {
      return (
        <div className={utils.isIphoneX() ? 'count-down iphoneX' : 'count-down'} style={{color: countDownTextColor}}>
          <span style={{marginRight: px2rem('-5px')}}>距结束：</span>{d !== "00" ? <span>{(String(d).length >= 3 ? '99' : d) + '天'}</span> : ''}
          <p className="square" style={{backgroundColor: countDownBgColor}}>{h}</p>:
          <p className="square" style={{backgroundColor: countDownBgColor}}>{m}</p>:
          <p className="square" style={{backgroundColor: countDownBgColor}}>{s}</p>
        </div>
      )
    } else {
      return <p className={utils.isIphoneX() ? 'count-down iphoneX' : 'count-down'} style={{color: countDownTextColor}}>活动已结束</p>
    }
  }

  render() {
    return (
      <Fragment>
        {this.renderCountDown()}
      </Fragment>
    )
  }

  startCountDown(end_time) {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
    const timestramp = end_time.replace(/-/g, "/");
    let finish_time = new Date(timestramp).getTime();
    let count_down = this.countDown(finish_time);
    this.setState({
      count_down: count_down,
    });
    this.timer = setInterval(() => {
      // 计算倒计时
      finish_time = new Date(timestramp).getTime();
      count_down = this.countDown(finish_time);
      this.setState({
        count_down: count_down,
      });
    }, 1000);
  }

  countDown(t) {
    var n = new Date().getTime(),
      c = t - n,
      d,
      h,
      m,
      s;
  
    // 结束执行
    if (c <= 0) {
      this.isEnded = true;
      return {
        d: "00",
        h: "00",
        m: "00",
        s: "00",
      };
    }
  
    d = parseInt(c / 1000 / 60 / 60 / 24);
    h = parseInt(c / 1000 / 60 / 60 - 24 * d);
    m = parseInt(c / 1000 / 60 - 24 * 60 * d - 60 * h);
    s = parseInt(c / 1000 - 24 * 60 * 60 * d - 60 * 60 * h - 60 * m);
  
    if (s < 10) {
      s = "0" + s;
    }
    if (m < 10) {
      m = "0" + m;
    }
    if (h < 10) {
      h = "0" + h;
    }
    if (d < 10) {
      d = "0" + d;
    }
    return {
      d: d,
      h: h,
      m: m,
      s: s,
    };
  }
}

export { CountDown };
export default CountDown;



// WEBPACK FOOTER //
// ./utils/countDown.js